
export const products = [
  {
    id: 'urban-rebel',
    name: 'URBAN REBEL',
    tagline: 'Built for real-world independence',
    price: 2499,
    originalPrice: 2999,
    category: 'Urban Series',
    description: 'The Urban Rebel is engineered for those who demand performance without compromise. Featuring a powerful 750W hub motor and a lightweight aluminum frame, this wheelchair conquers city streets with effortless grace. The integrated battery delivers up to 15 miles of range, while the advanced suspension system absorbs every bump and crack in the pavement.',
    features: [
      'Aircraft-grade aluminum alloy frame with desert sand finish',
      'Integrated LED lighting system with automatic brightness adjustment',
      'Electromagnetic braking for reliable stopping power in all conditions',
      'Smart connectivity via Bluetooth app with up to 3 user adjustable driving profiles',
      'Regenerative braking system to extend range on every outing',
      'Puncture-resistant tires with reflective sidewall strips'
    ],
    specs: {
      product: 'IND Mobility PowerTube',
      type: 'Lightweight powered axle upgrade kit',
      function: 'Converts a manual wheelchair into a joystick-driven hybrid e-chair',
      wheels: 'Custom 24-inch Spinergy wheels',
      battery: 'Removable ruggedized 20V 300Wh lithium-ion',
      range: '10 miles (16 km) per charge',
      topSpeed: 'Up to 7.5 mph (12 km/h)',
      chargeTime: 'Approx. 1.5 hours',
      powerTubeWeight: '9 lb (4.1 kg)',
      batteryWeight: '3.5 lb (1.6 kg)',
      systemWeight: '12.5 lb (5.7 kg)',
      compatibility: 'Most folding and rigid manual wheelchairs',
      installTime: 'Installs in minutes',
      removal: 'Quick-release, tool-free removal in seconds',
      joystick: 'Quick disconnect, ambidextrous use, attendant control',
      airTravel: 'FAA-compliant battery',
      warranty: '1-year limited battery warranty; 2-year limited motor warranty',
    },
    colors: [
      { name: 'Desert Sand', hex: '#c9b896' },
      { name: 'Gunmetal Gray', hex: '#4a4a4a' },
      { name: 'Arctic White', hex: '#f0f0f0' }
    ],
    variants: [
      { name: 'Standard', description: '750W Motor · 15mi Range', priceAdjust: 0 },
      { name: 'Sport', description: '750W Motor · 15mi Range · Sport Suspension', priceAdjust: 300 },
      { name: 'Pro', description: '900W Motor · 20mi Range · Full Suspension', priceAdjust: 700 },
    ],
    images: [
      'https://static.readdy.ai/image/1c1714daf9c4102bfceb8d84a95c03a8/5f8f3ebbb3f233d35f27f5cbfeb86faf.jpeg',
      'https://public.readdy.ai/ai/img_res/71018c81049335840fe9fa1d66ef9aed.jpg',
      'https://readdy.ai/api/search-image?query=desert%20sand%20beige%20electric%20wheelchair%20rear%20wheel%20hub%20motor%20detail%20with%20large%20black%20spoked%20wheel%20and%20white%20suspension%20arm%20professional%20product%20photography&width=800&height=800&seq=wc2025urban001c&orientation=squarish',
      'https://readdy.ai/api/search-image?query=desert%20sand%20beige%20electric%20wheelchair%20joystick%20controller%20detail%20on%20armrest%20with%20carbon%20fiber%20seat%20texture%20professional%20product%20photography&width=800&height=800&seq=wc2025urban001d&orientation=squarish'
    ],
    reviews: [
      { id: 1, author: 'Marcus T.', rating: 5, date: 'Dec 12, 2024', text: 'Absolutely love this chair. The range is incredible and it handles city streets like a dream. Best purchase I have made all year.', verified: true },
      { id: 2, author: 'Sarah K.', rating: 5, date: 'Nov 28, 2024', text: 'The build quality is outstanding. I use it daily for my commute and it has been flawless for 3 months straight. Highly recommend.', verified: true },
      { id: 3, author: 'James R.', rating: 4, date: 'Nov 15, 2024', text: 'Great performance and looks amazing. Only wish the charge time was a bit faster, but the range more than makes up for it.', verified: true }
    ],
    rating: 4.8,
    reviewCount: 127
  },
  {
    id: 'trooper',
    name: 'TROOPER',
    tagline: 'Reliable power for everyday adventures',
    price: 2799,
    originalPrice: 3299,
    category: 'All-Purpose Series',
    description: 'The Trooper is designed for users who need dependable performance day in and day out. With a robust 850W motor and 15-mile range, this wheelchair handles both urban environments and light outdoor terrain with confidence. The clean white finish and premium build quality make it a standout choice for those who value both form and function.',
    features: [
      'Reinforced aluminum frame with pristine white powder coat finish',
      'All-weather sealed electronics for reliable operation',
      'Dual LED headlights with high and low beam settings',
      'Quick-release battery system for convenient charging',
      'Ergonomic joystick with up to 3 user adjustable driving profiles',
      'Heavy-duty puncture-proof tires with enhanced grip'
    ],
    specs: {
      motor: '850W Brushless Hub Motor',
      battery: '48V 17.5Ah Lithium-Ion',
      range: '15 Miles',
      topSpeed: '8 mph',
      chargeTime: '2 Hours',
      weight: '56 lbs',
      maxLoad: '320 lbs',
      brakes: 'Electromagnetic with LED Brake Lights',
      tires: '14" Solid Puncture-Proof',
      suspension: 'Front & Rear, 70mm Travel',
      display: 'LCD Display with Backlight',
      gears: 'Single-Speed Direct Drive'
    },
    colors: [
      { name: 'Pure White', hex: '#ffffff' },
      { name: 'Pearl Silver', hex: '#d0d0d0' },
      { name: 'Cloud Gray', hex: '#b0b0b0' }
    ],
    variants: [
      { name: 'Standard', description: '850W Motor · 15mi Range', priceAdjust: 0 },
      { name: 'Plus', description: '850W Motor · 15mi Range · Extended Battery', priceAdjust: 350 },
      { name: 'Pro', description: '1000W Motor · 20mi Range · Premium Package', priceAdjust: 800 },
    ],
    images: [
      'https://static.readdy.ai/image/1c1714daf9c4102bfceb8d84a95c03a8/7e9a4138085baee2a0c0bef3ad4f88fc.jpeg',
      'https://readdy.ai/api/search-image?query=close%20up%20detail%20of%20pure%20white%20electric%20wheelchair%20showing%20green%20lithium%20battery%20pack%20mounted%20under%20carbon%20fiber%20seat%20with%20white%20suspension%20components%20professional%20product%20photography&width=800&height=800&seq=wc2025trooper001b&orientation=squarish',
      'https://readdy.ai/api/search-image?query=pure%20white%20electric%20wheelchair%20rear%20wheel%20hub%20motor%20detail%20with%20large%20black%20spoked%20wheel%20and%20white%20suspension%20arm%20professional%20product%20photography&width=800&height=800&seq=wc2025trooper001c&orientation=squarish',
      'https://readdy.ai/api/search-image?query=pure%20white%20electric%20wheelchair%20joystick%20controller%20detail%20on%20armrest%20with%20carbon%20fiber%20seat%20texture%20professional%20product%20photography&width=800&height=800&seq=wc2025trooper001d&orientation=squarish'
    ],
    reviews: [
      { id: 1, author: 'Jennifer L.', rating: 5, date: 'Jan 8, 2025', text: 'The Trooper has exceeded all my expectations. The white finish looks stunning and the battery life is phenomenal. Perfect for my daily routine.', verified: true },
      { id: 2, author: 'Robert M.', rating: 5, date: 'Dec 22, 2024', text: 'Solid build quality and smooth ride. The quick-release battery is a game changer for charging convenience. Highly recommend.', verified: true },
      { id: 3, author: 'Patricia K.', rating: 4, date: 'Dec 10, 2024', text: 'Great wheelchair with excellent range. The white color stays clean surprisingly well. Very happy with this purchase.', verified: true }
    ],
    rating: 4.8,
    reviewCount: 94
  },
  {
    id: 'night-rider',
    name: 'NIGHT RIDER',
    tagline: 'Own the darkness',
    price: 2899,
    originalPrice: 3399,
    category: 'Stealth Series',
    description: 'The Night Rider is designed for those who come alive after dark. Featuring an advanced integrated lighting system, stealth-black aesthetics, and whisper-quiet motor operation, this wheelchair is the ultimate nocturnal companion. Every detail is crafted for visibility, safety, and undeniable style.',
    features: [
      '360-degree integrated LED lighting with multiple modes',
      'Whisper-quiet direct drive for near-silent operation',
      'Reflective frame accents for enhanced nighttime visibility',
      'Ambient underglow lighting with customizable colors',
      'Night-vision compatible LCD display with auto-dimming',
      'Smart app with up to 3 user adjustable driving profiles'
    ],
    specs: {
      motor: '850W Brushless Hub Motor',
      battery: '48V 17.5Ah Lithium-Ion',
      range: '15 Miles',
      topSpeed: '8 mph',
      chargeTime: '2 Hours',
      weight: '56 lbs',
      maxLoad: '320 lbs',
      brakes: 'Electromagnetic with LED Brake Lights',
      tires: '14" Reflective Solid Tires',
      suspension: 'Front & Rear, 70mm Travel',
      display: 'Auto-Dimming LCD Display',
      gears: 'Single-Speed Direct Drive'
    },
    colors: [
      { name: 'Midnight Black', hex: '#0d0d0d' },
      { name: 'Shadow Gray', hex: '#2d2d2d' },
      { name: 'Stealth Matte', hex: '#1a1a1a' }
    ],
    variants: [
      { name: 'Standard', description: '850W Motor · 15mi Range', priceAdjust: 0 },
      { name: 'Sport', description: '850W Motor · 15mi Range · Enhanced LEDs', priceAdjust: 350 },
      { name: 'Pro', description: '1000W Motor · 20mi Range · Full Light Kit', priceAdjust: 800 },
    ],
    images: [
      'https://readdy.ai/api/search-image?query=professional%20product%20photography%20of%20modern%20electric%20wheelchair%20with%20carbon%20fiber%20textured%20seat%20and%20backrest%20large%20black%20spoke%20wheels%20white%20suspension%20arms%20matte%20black%20colored%20frame%20green%20battery%20pack%20mounted%20under%20seat%20joystick%20controller%20on%20armrest%20LED%20lighting%20accents%20outdoor%20concrete%20background%20three%20quarter%20front%20angle%20view%20showing%20full%20wheelchair%20structure%20clean%20minimalist%20design&width=800&height=800&seq=wc2025night001a&orientation=squarish',
      'https://readdy.ai/api/search-image?query=close%20up%20detail%20of%20matte%20black%20electric%20wheelchair%20showing%20green%20lithium%20battery%20pack%20with%20LED%20lighting%20accents%20mounted%20under%20carbon%20fiber%20seat%20with%20white%20suspension%20components%20professional%20product%20photography&width=800&height=800&seq=wc2025night001b&orientation=squarish',
      'https://readdy.ai/api/search-image?query=matte%20black%20electric%20wheelchair%20rear%20wheel%20hub%20motor%20detail%20with%20large%20black%20spoked%20wheel%20reflective%20tire%20and%20white%20suspension%20arm%20with%20LED%20underglow%20professional%20product%20photography&width=800&height=800&seq=wc2025night001c&orientation=squarish',
      'https://readdy.ai/api/search-image?query=matte%20black%20electric%20wheelchair%20joystick%20controller%20detail%20on%20armrest%20with%20carbon%20fiber%20seat%20texture%20and%20LED%20display%20lighting%20professional%20product%20photography&width=800&height=800&seq=wc2025night001d&orientation=squarish'
    ],
    reviews: [
      { id: 1, author: 'Alex N.', rating: 5, date: 'Jan 10, 2025', text: 'The lighting system on this thing is insane. I feel completely safe traveling at night and it looks absolutely incredible.', verified: true },
      { id: 2, author: 'Rachel B.', rating: 5, date: 'Dec 30, 2024', text: 'So quiet you can barely hear it. The stealth factor is real. Plus the underglow gets compliments everywhere I go.', verified: true },
      { id: 3, author: 'Chris D.', rating: 4, date: 'Dec 18, 2024', text: 'Perfect for my late night commutes. The auto-dimming display is a nice touch. Would love even more color options for the LEDs.', verified: true }
    ],
    rating: 4.7,
    reviewCount: 64
  }
];